import { Skeleton } from '@mui/material';

const LoadingSkeleton = () => {
  return (
    <div className='mt-4'>
      <Skeleton className='mb-[20px]' variant='rounded' height={76} />
      <div className='flex gap-[15px] mb-[20px]'>
        <Skeleton className='flex-1' variant='rounded' height={76} />
        <Skeleton className='flex-1' variant='rounded' height={76} />
      </div>
      <div className='flex gap-[15px] mb-[20px]'>
        <Skeleton className='flex-1' variant='rounded' height={76} />
        <Skeleton className='flex-1' variant='rounded' height={76} />
      </div>
      <hr className='-mx-[32px] my-5' />
      <div className='flex justify-between gap-[15px] mb-[20px]'>
        <Skeleton variant='rounded' height={48} width={126} />
        <div className='flex justify-end gap-[12px]'>
          <Skeleton className='flex-1' variant='rounded' height={48} width={138} />
          <Skeleton className='flex-1' variant='rounded' height={48} width={166} />
        </div>
      </div>
    </div>
  );
};

export default LoadingSkeleton;
